// extracted by mini-css-extract-plugin
export var container = "ModalWithHeading-module--container--327bf";
export var content = "ModalWithHeading-module--content--3314e";
export var description = "ModalWithHeading-module--description--b2eba";
export var heading = "ModalWithHeading-module--heading--7f3b6";
export var title = "ModalWithHeading-module--title--d4d1e";